import { IEnv } from './environment.interface';

export const environment: IEnv = {
  production: true,
  camApi: {
    baseUrl: 'https://staging-api-2.udotrucpilot.org/cam',
    deviceToken: ' IpY4vP46YhoDwEQa3GOP0em8K?5ag23iwIqs1OXwTdsyam6paO!i1RJWSHqtMO0t'
  },
  authApi: {
    accessToken: 'CH6DrZrtGqmUsUDRodUAvrEVuAaYqMJZC5ULk8zNvLNs',
    baseUrl: 'https://staging-api-2.udotrucpilot.org/auth'
  },
  odometerApi: {
    baseUrl: 'https://staging-odometer.clearroad.io'
  },
  geoprocessingApi: {
    baseUrl: 'https://staging-api-2.udotrucpilot.org/geoprocessing'
  },
  vinApi: {
    accessToken: '4zKPyBR1KFsujggaueURbH8esWrGzywaGNkCxMJaN6Lc',
    baseUrl: 'https://api.clearroadev.xyz/vin'
  },
  hereApi: {
    // id: 'OMIgHGvZUeSki9FkFYpK',
    // code: 'HfVj3DBsE5EghgVMo32m2g'
    id: '1jNke1nVayWVMmjyoLqh',
    code: 'z6wQteiL5TJhQnVlK02fWUdxj3jeztP44YwABb4ETgc'
  },
  superAdmin: {
    key: 'CRAdmin4321',
  }
};
